import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import nine from '../assets/svg/projects/nine.svg'
import ten from '../assets/svg/projects/ten.svg'
import eleven from '../assets/svg/projects/eleven.svg'
import twelve from '../assets/svg/projects/twelve.svg'
import thirteen from '../assets/svg/projects/thirteen.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'CryptoSpy',
        projectDesc: 'A front-end application to track and compare the prices of various popular cryptocurrencies.',
        tags: ['React.JS', 'Chart.JS', 'Material UI', 'CoinGecko API', 'Framer Motion'],
        code: 'https://github.com/ahanban15/CryptoSpy',
        demo: 'https://crypto-spy-seven.vercel.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'NowChat',
        projectDesc: 'A full-stack web application to chat with registered users in real-time.',
        tags: ['MERN', 'JWT', 'Socket.IO', 'Tailwind CSS', 'Daisy UI', 'Zustand'],
        code: 'https://github.com/ahanban15/NowChat',
        demo: 'https://nowchat.onrender.com/',
        image: two
    },
    {
        id: 3,
        projectName: 'Tutoria',
        projectDesc: 'A full-stack web portal to edit, post and view dev. articles and tutorials.',
        tags: ['MERN', 'JWT', 'GAuth.', 'REDUX', 'CRUD', 'Zustand', 'Flowbite React'],
        code: 'https://github.com/ahanban15/Tutoria',
        demo: 'https://tutoria-naiz.onrender.com/',
        image: three
    },
    {
        id: 4,
        projectName: 'Cinomender',
        projectDesc: 'Movie recommender system.',
        tags: ['Python', 'TMDB API', 'Flask', 'Streamlit'],
        code: 'https://github.com/ahanban15/Cinomender',
        demo: 'https://github.com/ahanban15/Cinomender',
        image: four
    },
    {
        id: 5,
        projectName: 'BandyAssist',
        projectDesc: 'Desktop voice AI assistant',
        tags: ['Python', 'PyAudio', 'Pyttsx3', 'PyAutoGUI'],
        code: 'https://github.com/ahanban15/BandyAssist',
        demo: 'https://github.com/ahanban15/BandyAssist',
        image: five
    },
    {
        id: 6,
        projectName: 'Bankerly',
        projectDesc: 'Fully functional Bank management website. ',
        tags: ['HTML', 'CSS', 'JS', 'Bootstrap', 'MySQL', 'PHP', 'XAMPP'],
        code: 'https://github.com/ahanban15/Bank-DBMS-Mini-Project',
        demo: 'https://github.com/ahanban15/Bank-DBMS-Mini-Project',
        image: six
    },
    {
        id: 7,
        projectName: 'Job Portal',
        projectDesc: 'An Indeed.com clone functioning as a job search portal',
        tags: ['HTML', 'CSS', 'JS', 'Bootstrap', 'MERN'],
        code: 'https://github.com/ahanban15/Job-Search-Portal-Website',
        demo: 'https://github.com/ahanban15/Job-Search-Portal-Website',
        image: seven
    },
    {
        id: 8,
        projectName: 'Credit-Card Fraud Detection',
        projectDesc: 'ML Model that detects fraud transactions',
        tags: ['Python', 'Random Forest Classifier'],
        code: 'https://github.com/ahanban15/CreditCard_Fraud-Detection',
        demo: 'https://github.com/ahanban15/CreditCard_Fraud-Detection',
        image: eight
    },
    {
        id: 9,
        projectName: 'e-Wallet',
        projectDesc: 'Full stack MERN based e-wallet',
        tags: ['MERN', 'Redux', 'Transaction API'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: nine
    },
    {
        id: 10,
        projectName: 'Converto',
        projectDesc: 'Flutter App for Unit Conversion',
        tags: ['Flutter'],
        code: 'https://github.com/ahanban15/Converto',
        demo: 'https://github.com/ahanban15/Converto',
        image: ten
    },
    {
        id: 11,
        projectName: 'Register.io',
        projectDesc: 'Practice project of learning how to setup profile page, login page, password handling, OTP, JWT Token',
        tags: ['MERN', 'JWT', 'Auth'],
        code: 'https://github.com/ahanban15/MERN-registration-app',
        demo: 'https://github.com/ahanban15/MERN-registration-app',
        image: eleven
    },
    {
        id: 12,
        projectName: 'Face Attendance App',
        projectDesc: 'Face Attendance and recognition app',
        tags: ['openCV', 'Python', 'Encoder'],
        code: 'https://github.com/ahanban15/FaceRecognition-and-Attendance',
        demo: 'https://github.com/ahanban15/FaceRecognition-and-Attendance',
        image: twelve
    },
    {
        id: 13,
        projectName: 'AudioPlayer + SnakeGame',
        projectDesc: 'Consortium of all java swing projects',
        tags: ['JAVA Swing'],
        code: 'https://github.com/ahanban15/Java-Swing-Projects',
        demo: 'https://github.com/ahanban15/Java-Swing-Projects',
        image: thirteen
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/